import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Card, StatusPill } from "@/components/kit";

export default function IncompleteSignups() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/membership/incomplete-signups").then((r) => setData(r.data)).catch(() => toast.error("Couldn't load the list")); }, []);
  return (
    <div className="max-w-4xl" data-testid="incomplete-signups-page">
      <h1 className="font-zilla text-3xl sm:text-4xl font-semibold mb-1">Incomplete Signups</h1>
      <p className="text-[16px] text-ink/70 mb-6">People who created a login but haven't finished the membership questions. They aren't members and never appear in member lists or counts. On their next sign-in they go straight to the membership questions.</p>
      <Card className="overflow-hidden" data-testid="incomplete-signups-list">
        {!data && <div className="p-8 text-center text-ink/55">Loading…</div>}
        {data && data.items.length === 0 && <div className="p-8 text-center text-ink/55">No incomplete signups.</div>}
        {data?.items.map((u) => (
          <div key={u.user_id} data-testid={`incomplete-${u.user_id}`} className="flex items-center justify-between gap-3 px-5 py-3 border-b border-ink/8 last:border-0">
            <div className="min-w-0">
              <div className="text-[15px] font-semibold truncate">{u.name || "—"}</div>
              <div className="text-[13px] text-ink/60 truncate">{u.email}{u.created_at ? ` · signed up ${u.created_at.slice(0, 10)}` : ""}</div>
            </div>
            <StatusPill tone="gold">{u.label}</StatusPill>
          </div>
        ))}
      </Card>
      {data && <p className="text-[14px] text-ink/55 mt-3" data-testid="incomplete-count">{data.total} incomplete signup{data.total === 1 ? "" : "s"}</p>}
    </div>
  );
}
